// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".root .loader-wrapper {\n    position: absolute;\n    background: #ffffff;\n    border: #ffffff;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    right: 0;\n    z-index: 2;\n    text-align: center;\n  }\n    .root .loader-wrapper--hide {\n      display: none;\n    }\n  .root .loader {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate3D(-50%, -50%, 0);\n  }\n", ""]);
// Exports
module.exports = exports;
